import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { HelpCenterSettingsCreateArticleAppEntryPoint as main } from '@atlassian/jira-spa-apps-help-center-settings-create-article/entrypoint.tsx';

export const helpCenterSettingCreateArticleAppPageEntryPoint = createPageEntryPoint({
	main,
	topNavigationMenuId: MENU_ID.HELP_CENTER_SETTINGS,
});
